export default __webpack_public_path__ + "static/media/news50.939c6dae.jpg";